import React, { Component } from 'react'
import PropTypes from 'propTypes'
import { connect } from 'react-redux'
import { updateHistory } from './reducks'

class SessionHistory extends Component {
  static propTypes = {
    history: PropTypes.object,
  }

  state = {
    unlisten: undefined,
  }

  componentDidMount() {
    const { history, updateHistory } = this.props

    // Push the initial location
    updateHistory(history.location, 'PUSH')

    // Now listen to changes in the history and act accordingly
    const unlisten = history.listen(updateHistory)
    this.setState({ unlisten })
  }

  componentWillUnmount() {
    // Remove history listener when unmounted
    if (this.state.unlisten) this.state.unlisten()
  }

  render() {
    return null
  }
}

export default connect(null, dispatch => ({
  updateHistory: (location, action) => dispatch(updateHistory(location, action)),
}))(SessionHistory)
